import { type PlanType } from '@/types';

import { type PlanFeatureType } from './consts';
import { usePremiumAccess } from './usePremiumAccess';
import { useUserPlanManager } from './UserPlanManagerProvider';

export const useUpsellingGuard = () => {
  const { userPlanManager } = useUserPlanManager();
  const { openFeaturePaywall } = usePremiumAccess();

  return <T>(
    action: () => T,
    options: {
      feature: PlanFeatureType;
      from: string;
      initialPlanType?: Exclude<PlanType, 'FREE'>;
      moreConditionForGuard?: boolean;
      onGuard?: () => void;
    },
  ): T | void => {
    const canAccessFeature = userPlanManager.canAccessFeature(options.feature);
    const shouldGuard =
      !canAccessFeature && (options.moreConditionForGuard ?? true);
    if (shouldGuard) {
      if (options.onGuard) {
        options.onGuard();
        return;
      }
      const featurePlanType = userPlanManager.getFeaturePlanType(
        options.feature,
      );
      // 판정·조회는 비동기지만 가드 자체는 동기 계약을 유지한다.
      // 제네릭 T 는 통과 분기로만 흐르므로, 여기서 await 해도 얻을 게 없고
      // 소비처 12곳의 시그니처만 오염된다.
      void openFeaturePaywall({
        requiredPlan: featurePlanType,
        highlightPlan: options.initialPlanType,
        from: options.from,
      });
      return;
    }
    return action();
  };
};
